import { render, staticRenderFns } from "./userManualMpago.vue?vue&type=template&id=552738a8&"
import script from "./userManualMpago.vue?vue&type=script&lang=js&"
export * from "./userManualMpago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports